<button [class.disabled]="value === minValue" (click)="handleStep(-1)" [attr.aria-label]="ariaLabel ? 'Decrease ' + ariaLabel: null">
    <icon name="minus"></icon>
</button>
<div class="value-display">{{value || '--'}}</div>
<button [class.disabled]="value === maxValue" (click)="handleStep(1)" [attr.aria-label]="ariaLabel ? 'Increase ' + ariaLabel: null">
    <icon name="plus"></icon>
</button>